import { z } from 'zod';

/**
 * Einzelner Eintrag im Activity-Feed.
 * Basiert auf dem AuditLog-Model.
 */
export const ActivityFeedItemSchema = z.object({
  id: z.string(),
  /** Aktion, z.B. "ticket.assign" oder "event.create". */
  action: z.string(),
  /** Betroffene Entität, z.B. "ticket" oder "event". */
  entity: z.string(),
  /** ID der betroffenen Entität. */
  entityId: z.string(),
  createdAt: z.coerce.date(),
  user: z.object({
    id: z.string(),
    displayName: z.string().nullable(),
    firstName: z.string().nullable(),
    email: z.string(),
  }),
});

/** TypeScript Type — abgeleitet aus ActivityFeedItemSchema */
export type ActivityFeedItem = z.infer<typeof ActivityFeedItemSchema>;

/**
 * Activity-Feed — Liste von Feed-Einträgen mit Gesamtzahl.
 */
export const ActivityFeedSchema = z.object({
  items: z.array(ActivityFeedItemSchema),
  total: z.number().int(),
});

/** TypeScript Type — abgeleitet aus ActivityFeedSchema */
export type ActivityFeed = z.infer<typeof ActivityFeedSchema>;
